import { match as MatchProps } from 'react-router-dom'
import { Spin, useGetGapReport, useGetGapReportDocument } from '@pepper/ui'
import { useSelectedCompanyId } from 'utils/functions/misc'

import Metrics from './Metrics/Metrics'
import Insights from './Insights/Insights'

import s from './ContentGapReport.module.css'
import { GapReportDocument } from '@pepper/utils/src/types/seo'

type Props = {
  match: MatchProps<{ reportId: string; documentId: string }>
}

const ContentGapReport = ({ match }: Props) => {
  const reportId = match?.params.reportId
  const documentId = match?.params.documentId
  const companyId = useSelectedCompanyId()

  const { data: documentData, isLoading: isDocumentLoading } =
    useGetGapReportDocument<GapReportDocument>({
      reportId,
      companyId,
      documentId,
    })

  const { data: reportData, isLoading: isReportLoading } = useGetGapReport({
    reportId,
    companyId,
  })

  if (isReportLoading || isDocumentLoading) {
    return (
      <div className={s.spinWrapper}>
        <Spin />
      </div>
    )
  }

  return (
    <div className={s.wrapper}>
      {documentData?.document && (
        <>
          {reportData && (
            <Metrics document={documentData.document} report={reportData} />
          )}
          <Insights document={documentData.document} />
        </>
      )}
    </div>
  )
}

export default ContentGapReport
